import { getObjectKeys, mapFilter, omitKeys } from "@hex-insights/core";

// TODO move to core (App Modules)
export function mergeFilterInputs<T extends { search?: string | null; and?: T[] | null }>(
	primary: T,
	...others: (T | null | undefined)[]
): Pick<T, "search" | "and"> {
	if (others.length === 0) {
		return primary;
	}

	return {
		search: primary.search ?? "",
		and: mapFilter(
			[primary, ...others],
			(e) => (e ? omitKeys(e, ["search"]) : e),
			(e) => !!e && getObjectKeys(e).length > 0,
		) as T[],
	};
}
